// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from '../../i18n/I18n';


import ViewUtils from '../../utils/ViewUtils';

// -- views
import { Modal } from 'react-bootstrap';
import Cropper from 'react-cropper';
import OnLoadingContentViewForModal from '../OnLoadingContentViewForModal';

/**
 */
export default class CropImageModal extends Component {

  static defaultProps = {
    width: null,

    height: null
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,

    onHide: PropTypes.func.isRequired,

    imageUrl: PropTypes.string.isRequired,

    aspectRatio: PropTypes.number.isRequired,

    onValidate: PropTypes.func.isRequired,

    /**
     * The width to set to the cropped image.
     * @type {[type]}
     */
    width: PropTypes.number,

    /**
     * The height to set to the cropped image.
     */
    height: PropTypes.number
  };

  state = {
    loading: false
  };

  // -- events - modal

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  // -- events crop

  onValidate = () => {
    const canvas = this.refs.cropper.getCroppedCanvas();
    this.setState({
      loading: true
    }, () => {
      if (!_.isNull(this.props.width) && !_.isNull(this.props.height)) {
        // resize image
        ViewUtils.resizeCanvasImg(canvas, this.props.width, this.props.height)
        .then((newImgDataUrl) => {
          this.setState({
            loading: false
          }, () => {
            this.props.onValidate(newImgDataUrl);
            this.props.onHide();
          });

        });

      } else {
        const imageDataUrl = canvas.toDataURL();
        this.setState({
          loading: false
        }, () => {
          this.props.onValidate(imageDataUrl);
          this.props.onHide();
        });
      }
    });

    // test:
    //    const png = imageDataUrl.split(',')[1];
    //    const file = new Blob([window.atob(png)], { type: 'image/png', encoding: 'utf-8' });
    //    console.log(file);

  };

  onCrop = () => {
  };

  // -- renderers

  renderBody() {
    if (this.state.loading) {
      return (
        <OnLoadingContentViewForModal
        />
      );
    }

    return (
      <div className="crop_modal">

        <div className="top-buffer-20">
          <Cropper
            ref="cropper"
            src={this.props.imageUrl}
            style={ { height: 400, width: '100%' } }
            // Cropper.js options. See https://github.com/fengyuanchen/cropperjs#aspectratio
            aspectRatio={this.props.aspectRatio}
            guides={false}
            crop={this.onCrop}
            viewMode={1}
          />
        </div>

        <div className="text-center top-buffer-30">
          <button
            onClick={this.onValidate}
            className="btn btn-primary"
          >
            {I18n.tr('components.crop_image.submit')}
          </button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onClose}
        backdrop="static"
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {I18n.tr('components.crop_image.title')}
          </Modal.Title>

        </Modal.Header>

        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/CropImageModal.js